import styled from 'styled-components';

export const $InitialLoaderContainer = styled('div')`
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
